import React from "react";
import clsx from "clsx";

import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Box from "@material-ui/core/Box";
import MuiTableSortLabel from "@material-ui/core/TableSortLabel";

import { SortOrder } from "interfaces/SortOrder";
import { checkSortingType } from "utils/sort-utils";
import useStyles from "./styles";

interface Props {
  children?: React.ReactNode;
  name?: string;
  order?: SortOrder;
  orderBy?: string;
  onSortClick?: (orderBy: string, order: SortOrder) => void;
  disabled?: boolean;
  hideSortIcon?: boolean;
  className?: string;
  firstClickSort?: SortOrder;
}

const TableSortLabel = React.memo((props: Props) => {
  const {
    children,
    name,
    order,
    orderBy,
    onSortClick,
    disabled,
    hideSortIcon,
    className,
    firstClickSort = SortOrder.DESC
  } = props;
  const classes = useStyles();
  const isActive = orderBy === name;
  const { isAsc, isDesc } = checkSortingType(order);

  const handleSortClick = () => {
    if (isActive) {
      onSortClick(name, isAsc ? SortOrder.DESC : SortOrder.ASC);
    } else {
      onSortClick(name, firstClickSort);
    }
  };

  return (
    <MuiTableSortLabel
      active={isActive}
      onClick={handleSortClick}
      direction={order}
      disabled={disabled}
      hideSortIcon={hideSortIcon}
      IconComponent={() => (
        <Box className={clsx(classes.icons, className)}>
          <Box
            className={clsx(classes.iconUp, {
              [classes.iconSort]: isActive && isAsc
            })}
          >
            <ArrowDropUpIcon />
          </Box>
          <Box
            className={clsx(classes.iconDown, {
              [classes.iconSort]: isActive && isDesc
            })}
          >
            <ArrowDropDownIcon />
          </Box>
        </Box>
      )}
    >
      {children}
    </MuiTableSortLabel>
  );
});

export default TableSortLabel;
